import angular from "angular";

angular
    .module('app')
    .component('testComponent', {
        template: require('./test-component.html'),
        controller: ['$http', 'Upload', controller],
        bindings: {
            //
        }
    });

function controller($http, Upload) {

    let $ctrl = this;
    $ctrl.video = null;
    $ctrl.awsVideoUrl = null;
    $ctrl.videos = [
        {
            name: 'Kekw',
            infos: [
                {
                    'quality': '360'
                },
                {
                    'quality': '480'
                },
                {
                    'quality': '720'
                },
                {
                    'quality': '1080'
                },
            ],
        }
    ];
    $ctrl.$onInit = function () {
        console.log($ctrl.videos[0].infos);
    };

    $ctrl.upload = function () {
        $ctrl.videos.push({
            name: $ctrl.video.name,
            infos: [
                {
                    'quality': '360'
                },
                {
                    'quality': '480'
                },
                {
                    'quality': '720'
                },
                {
                    'quality': '1080'
                },
            ],
        });
        Upload.upload({
            url: '/admin/videos/test/upload',
            data: {video: $ctrl.video},
            resumeChunkSize: '10MB'
        }).then(function (resp) {
            $ctrl.awsVideoUrl = resp.data;
            $ctrl.uploadedVideo = resp.data.path;
            console.log('resp', resp);
        }, function (resp) {
            // console.log('Error status: ' + resp.status);
        }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            console.log('progress: ' + progressPercentage + '% ');
        });
    };
}
